import { font, themedColor, disabledInteraction, cssValue } from '@lemonade-hq/cdk';
import { rgba } from 'polished';
import styled, { css } from 'styled-components';
import { rounded } from '../../styles/common.esm.js';
import { spinnerStyles } from '../Spinner/Spinner.esm.js';
import { FLAVOR_STYLES } from './shared.esm.js';
export { FLAVOR_STYLES as BUTTON_FLAVOR_STYLES } from './shared.esm.js';

function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n    padding: 8px;\n    font-size: 14px;\n    ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n    padding: 15px;\n    font-size: 14px;\n    ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n    padding: 20px;\n    font-size: 16px;\n    ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n    width: 100%;\n    height: 100%;\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n    color: ",
        ";\n    ",
        ";\n    padding-left: ",
        "px;\n\n    &::before {\n      content: '';\n      position: absolute;\n      left: ",
        ";\n      top: calc(50% - ",
        "px);\n      ",
        "\n    }\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n    ",
        "\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n    ",
        "\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n      box-shadow: 0px 10px 40px -10px ",
        ";\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n    ",
        "\n    ",
        "\n    ",
        "\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n      height: ",
        ";\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n      min-width: ",
        ";\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n  text-align: center;\n  color: ",
        ";\n  outline: none;\n  cursor: pointer;\n  text-transform: uppercase;\n  position: relative;\n  text-decoration: none;\n  white-space: nowrap;\n  transform-origin: center;\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n\n    ",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
/* STYLES ******************************************************************/ var SIZE_STYLES = {
    tiny: css(_templateObject(), rounded),
    small: css(_templateObject1(), rounded),
    big: css(_templateObject2(), rounded),
    boundless: css(_templateObject3())
};
var SPINNER_SIZES = {
    tiny: 20,
    small: 24,
    big: 24,
    boundless: 24,
    hugging: 24
};
var SPINNER_COLORS = {
    primary: "white",
    ghost: "primary",
    standard: "white",
    dark: "white",
    simple: "glass",
    bright: "glass"
};
function loadingStyle(centerLoader, flavor, size) {
    return css(_templateObject4(), function(param) {
        var theme = param.theme;
        return centerLoader ? "transparent" : rgba(theme.colors[SPINNER_COLORS[flavor]], 0.5);
    }, disabledInteraction, SPINNER_SIZES[size] * 2, centerLoader ? "calc(50% - ".concat(SPINNER_SIZES[size] / 2, "px)") : "12.5px", SPINNER_SIZES[size] / 2, function(param) {
        var theme = param.theme;
        return spinnerStyles({
            size: SPINNER_SIZES[size],
            color: theme.colors[SPINNER_COLORS[flavor]]
        });
    });
}
var Button = styled.button(_templateObject11(), font("main", {
    fontWeight: 700
}), themedColor("white"), function(param) {
    var _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled;
    return css(_templateObject5(), disabled && disabledInteraction);
}, function(param) {
    var _param_size = param.size, size = _param_size === void 0 ? "small" : _param_size;
    return css(_templateObject6(), SIZE_STYLES[size]);
}, function(param) {
    var _param_flavor = param.flavor, flavor = _param_flavor === void 0 ? "standard" : _param_flavor, _param_size = param.size, size = _param_size === void 0 ? "small" : _param_size, _param_centerLoader = param.centerLoader, centerLoader = _param_centerLoader === void 0 ? true : _param_centerLoader, _param_isLoading = param.isLoading, isLoading = _param_isLoading === void 0 ? false : _param_isLoading, _param_glowing = param.glowing, glowing = _param_glowing === void 0 ? false : _param_glowing, theme = param.theme;
    return css(_templateObject8(), FLAVOR_STYLES[flavor], flavor === "primary" && glowing && css(_templateObject7(), rgba(theme.colors.primary, 0.5)), isLoading && loadingStyle(centerLoader, flavor, size));
}, function(param) {
    var height = param.height;
    return height != null && css(_templateObject9(), cssValue(height));
}, function(param) {
    var hugging = param.hugging, minWidth = param.minWidth;
    return !hugging && minWidth != null && css(_templateObject10(), cssValue(minWidth));
});

export { Button };
